"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intOperators = exports.inetOperators = exports.filterOperators = exports.caseSensitiveRegexOperators = exports.allRegexOperators = void 0;
exports.isStringOrRegexOperator = isStringOrRegexOperator;
exports.stringOperators = exports.stringAndRegexOperators = exports.standardFilterOperators = exports.rightFilterFieldOperators = exports.regexOperators = exports.parametricOperators = void 0;
const _filterOperators = {
  '=': 'equals',
  '<>': 'does not equal',
  '>': 'is greater than',
  '<': 'is less than',
  ILIKE: 'contains',
  'NOT ILIKE': 'does not contain',
  '~*': 'matches regex',
  '~': 'matches regex',
  '!~*': 'does not match regex',
  '&': 'Bitwise AND (&)',
  misc_flags_set: 'matches Ultimate Exit',
  misc_flags_not_set: 'does not match Ultimate Exit',
  pdb_common: 'common with mine',
  pdb_not_common: 'not common with mine',
  field_equals: 'equals the value of',
  field_not_equal: 'does not equal the value of'
};

// it's slightly concerning that there are other operators which are NOT mapped by filterOperators

const filterOperators = exports.filterOperators = _filterOperators;
const intOperators = exports.intOperators = {
  '=': 'equals',
  '<>': 'does not equal',
  '>': 'is greater than',
  '<': 'is less than'
};
const stringOperators = exports.stringOperators = {
  '=': 'equals',
  '<>': 'does not equal',
  ILIKE: 'contains',
  'NOT ILIKE': 'does not contain'
};
const inetOperators = exports.inetOperators = {
  ILIKE: 'equals',
  '<>': 'does not equal'
};
const caseSensitiveRegexOperators = exports.caseSensitiveRegexOperators = {
  '~': 'matches regex',
  '!~': 'does not match regex'
};
const regexOperators = exports.regexOperators = {
  '~*': 'matches regex',
  '!~*': 'does not match regex'
};
const stringAndRegexOperators = exports.stringAndRegexOperators = {
  ILIKE: 'contains',
  'NOT ILIKE': 'does not contain',
  '~*': 'matches regex',
  '!~*': 'does not match regex'
};
function isStringOrRegexOperator(operator) {
  return operator in stringAndRegexOperators;
}
const allRegexOperators = exports.allRegexOperators = {
  '~': 'matches regex (case sens)',
  '~*': 'matches regex',
  '!~*': 'does not match regex'
};
const standardFilterOperators = exports.standardFilterOperators = {
  '=': 'equals',
  '<>': 'does not equal'
};
const rightFilterFieldOperators = exports.rightFilterFieldOperators = {
  field_equals: 'equals the value of',
  field_not_equal: 'does not equal the value of'
};
const parametricOperators = exports.parametricOperators = {
  market: '=',
  as_name: 'ILIKE',
  as_number: '=',
  bgp_aspath: '~',
  bgp_community: '~',
  city: 'ILIKE',
  cdn: 'ILIKE',
  connectivity_type: '=',
  country: '=',
  custom_dimension: '=',
  eth_mac: '=',
  device: '=',
  device_label: '=',
  dns_query: 'ILIKE',
  service_name: 'ILIKE',
  service_type: 'ILIKE',
  service_provider: 'ILIKE',
  ott_classification_type: '=',
  http_host_header: 'ILIKE',
  http_status: '=',
  http_url: 'ILIKE',
  interface_desc: 'ILIKE',
  interface_name: 'ILIKE',
  ip: 'ILIKE',
  network_boundary: '=',
  provider: '=',
  port: '=',
  region: 'ILIKE',
  site: 'ILIKE',
  site_market: 'ILIKE',
  tag: 'ILIKE',
  vlan: '=',
  cloud_provider: '=',
  gce_proj_id: '=',
  gce_vm_name: 'ILIKE',
  gce_region: '=',
  gce_zone: 'ILIKE',
  gce_vpn_snn: 'ILIKE',
  gce_vm_type: '=',
  aws_acc_id: '=',
  aws_vm_name: 'ILIKE',
  aws_vm_id: '=',
  aws_region: 'ILIKE',
  aws_zone: 'ILIKE',
  aws_zone_id: '=',
  aws_vm_type: '=',
  aws_pub_dns: 'ILIKE',
  aws_priv_dns: 'ILIKE',
  aws_vpc_id: '=',
  aws_subnet_id: '=',
  az_inst_id: 'ILIKE',
  az_inst_name: 'ILIKE',
  az_region: 'ILIKE',
  az_vnet: 'ILIKE',
  az_sub_id: 'ILIKE',
  az_rsrc_grp: 'ILIKE'
};